module.exports = __webpack_public_path__ + "static/media/Car finance-amico-2 1.59cbed0d.svg";